import { createScopedDescriptor, set } from 'quartz-core-utils/globalState/api';
import { createBrowserHistory } from 'history';
export const HISTORY_INSTANCE = createScopedDescriptor('historyInstance', 'EXECUTION_CONTEXT');
export function initializeHistory(basename) {
  const history = createBrowserHistory({
    basename
  });
  set(HISTORY_INSTANCE, history);
  return history;
}